import { PromoTile } from './PromoTile';
import { useSiteImages } from '../../hooks/useSiteImages';

interface AudienceFinderProps {
  onSelectGirls: () => void;
  onSelectBoys: () => void;
  onSelectAccessories: () => void;
}

function CapIcon() {
  return (
    <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M3 13c0-4 4-7 9-7s9 3 9 7M3 13c0 1.5 1 2 2 2h14c1 0 2-.5 2-2M3 13l-1 .3M21 13l1 .3M12 6V4"
      />
    </svg>
  );
}

export function AudienceFinder({ onSelectGirls, onSelectBoys, onSelectAccessories }: AudienceFinderProps) {
  const { siteImages } = useSiteImages();

  return (
    <div className="max-w-6xl mx-auto px-4 pt-10">
      <p className="text-xs font-bold uppercase tracking-[0.18em] text-chocolate-dark mb-4">
        O que você está procurando hoje?
      </p>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        <PromoTile label="Meninas" image={siteImages['finder-meninas']} onClick={onSelectGirls} />
        <PromoTile label="Meninos" image={siteImages['finder-meninos']} onClick={onSelectBoys} />
        <PromoTile
          label="Acessórios"
          image={siteImages['finder-acessorios']}
          icon={<CapIcon />}
          onClick={onSelectAccessories}
          className="col-span-2 md:col-span-1"
        />
      </div>
    </div>
  );
}
